import { AuthHttp } from 'app/infrastructure/common';
import { Injectable } from '@angular/core';
import { AppSettings } from 'app/infrastructure/settings';
import { Response, RequestOptions, URLSearchParams } from '@angular/http';

@Injectable()
export class SingaporePostalCodeService {
    constructor(private http: AuthHttp) { }

    getCssConfig(postalCode: string) {
        let params: URLSearchParams = new URLSearchParams();
        params.set('postalCode', postalCode);

        let options: RequestOptions = new RequestOptions({ search: params });
        return this.http.get(AppSettings.apiEndpoint + 'SingaporePostalCode/GetCoordinate', options)
            .map((response: Response) => response.json());
    }
}



// WEBPACK FOOTER //
// ./src/app/infrastructure/services/base/config/singaporepostalcode.service.ts